import React, { useState } from 'react';
import { TrophyIcon, StarIcon, ArrowUpIcon, AwardIcon, ZapIcon, TrendingUpIcon, CoinsIcon, UsersIcon } from 'lucide-react';
const topPerformers = [{
  rank: 1,
  name: 'Sarah Kim',
  role: 'Sr. Loan Originator',
  avatar: 'SK',
  loans: 23,
  volume: '$9.8M',
  avgClose: '24 days',
  color: '#2B8DC4'
}, {
  rank: 2,
  name: 'Priya Rajan',
  role: 'Loan Originator',
  avatar: 'PR',
  loans: 18,
  volume: '$7.2M',
  avgClose: '26 days',
  color: '#1A2B3C'
}, {
  rank: 3,
  name: 'Alex Chen',
  role: 'Loan Originator',
  avatar: 'AC',
  loans: 15,
  volume: '$5.8M',
  avgClose: '28 days',
  color: '#1E6FA0'
}, {
  rank: 4,
  name: 'Carlos Mendez',
  role: 'Branch Manager',
  avatar: 'CM',
  loans: 12,
  volume: '$4.9M',
  avgClose: '25 days',
  color: '#2B8DC4'
}, {
  rank: 5,
  name: 'Derek Liu',
  role: 'Processor',
  avatar: 'DL',
  loans: 11,
  volume: '$4.2M',
  avgClose: '27 days',
  color: '#1A2B3C'
}];
const coinLeaders = [{
  rank: 1,
  name: 'Sarah Kim',
  coins: 47,
  avatar: 'SK',
  color: '#2B8DC4'
}, {
  rank: 2,
  name: 'Marcus Thompson',
  coins: 38,
  avatar: 'MT',
  color: '#1A2B3C'
}, {
  rank: 3,
  name: 'Priya Rajan',
  coins: 35,
  avatar: 'PR',
  color: '#1E6FA0'
}, {
  rank: 4,
  name: 'Carlos Mendez',
  coins: 32,
  avatar: 'CM',
  color: '#2B8DC4'
}, {
  rank: 5,
  name: 'Derek Liu',
  coins: 28,
  avatar: 'DL',
  color: '#1A2B3C'
}];
const milestones = [{
  label: 'Total Loans Closed',
  value: '1,247',
  change: '+18% YoY',
  color: '#2B8DC4'
}, {
  label: 'Total Volume',
  value: '$487M',
  change: '+22% YoY',
  color: '#1A2B3C'
}, {
  label: 'Avg. Close Time',
  value: '26 days',
  change: '-4 days YoY',
  color: '#2B8DC4'
}, {
  label: 'Client Satisfaction',
  value: '4.8/5.0',
  change: '+0.3 YoY',
  color: '#1A2B3C'
}];
const rankLabels = ['🥇', '🥈', '🥉', '4', '5'];
export function HallOfFame() {
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-311">
      {/* Hero Banner */}
      <div style={{
      borderRadius: 16,
      padding: '32px 40px',
      marginBottom: 24,
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(118deg, #0D1B2A 0%, #1E6FA0 45%, #0D1B2A 100%)',
      minHeight: 160
    }} data-id="element-312">
        <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 18px, rgba(255,255,255,0.025) 18px, rgba(255,255,255,0.025) 36px)',
        pointerEvents: 'none'
      }} data-id="element-313" />
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '40%',
        height: '100%',
        background: 'linear-gradient(118deg, transparent 0%, rgba(43,141,196,0.2) 100%)',
        clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0% 100%)',
        pointerEvents: 'none'
      }} data-id="element-314" />
        <div style={{
        position: 'absolute',
        right: 40,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0.07,
        pointerEvents: 'none'
      }} data-id="element-315">
          <TrophyIcon size={160} color="white" data-id="element-316" />
        </div>
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 4,
        background: 'linear-gradient(90deg, #2B8DC4 0%, #3FA8E0 60%, transparent 100%)'
      }} data-id="element-317" />
        <div style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-318">
          <div style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.5)',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: 6
        }} data-id="element-319">
            Recognition
          </div>
          <h2 style={{
          fontSize: 32,
          fontWeight: 900,
          color: '#FFFFFF',
          margin: '0 0 6px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em',
          lineHeight: 1
        }} data-id="element-320">
            Hall of Fame 🏆
          </h2>
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: 14,
          margin: '0 0 16px',
          fontWeight: 500
        }} data-id="element-321">
            Celebrating the people who make Swift exceptional.
          </p>
          <div style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap'
        }} data-id="element-322">
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 800,
            background: '#2B8DC4',
            color: 'white',
            fontStyle: 'italic'
          }} data-id="element-323">
              February 2025
            </span>
          </div>
        </div>
      </div>

      {/* Company Stats */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 16,
      marginBottom: 24
    }} data-id="element-324">
        {milestones.map(m => <div key={m.label} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '20px 22px',
        border: '1px solid #E4EAF6',
        borderTopColor: m.color,
        borderTopWidth: 3,
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-325">
            <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 60,
          height: 60,
          background: `${m.color}06`,
          clipPath: 'polygon(100% 0, 100% 100%, 0 0)'
        }} data-id="element-326" />
            <div style={{
          marginBottom: 8
        }} data-id="element-327">
              <span style={{
            fontSize: 11,
            fontWeight: 700,
            color: m.color,
            background: `${m.color}12`,
            padding: '2px 8px',
            borderRadius: 4,
            fontStyle: 'italic'
          }} data-id="element-328">
                {m.change}
              </span>
            </div>
            <div style={{
          fontSize: 34,
          fontWeight: 900,
          color: '#1A2B3C',
          letterSpacing: '-0.04em',
          fontStyle: 'italic',
          lineHeight: 1,
          marginBottom: 8,
          position: 'relative',
          display: 'inline-block'
        }} data-id="element-329">
              {m.value}
              <div style={{
            position: 'absolute',
            bottom: -4,
            left: 0,
            width: '60%',
            height: 3,
            borderRadius: 2,
            background: m.color
          }} data-id="element-330" />
            </div>
            <div style={{
          fontSize: 12,
          color: '#5A6A8A',
          fontWeight: 600,
          marginTop: 8
        }} data-id="element-331">
              {m.label}
            </div>
          </div>)}
      </div>

      <div style={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr',
      gap: 20,
      marginBottom: 24
    }} data-id="element-332">
        {/* LO Leaderboard */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#2B8DC4',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-333">
          <h3 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 20px',
          fontStyle: 'italic',
          letterSpacing: '-0.02em',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-334">
            <TrendingUpIcon size={18} color="#2B8DC4" data-id="element-335" /> Loan Officer
            Leaderboard
          </h3>
          <div style={{
          overflowX: 'auto'
        }} data-id="element-336">
            <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            textAlign: 'left'
          }} data-id="element-337">
              <thead data-id="element-338">
                <tr style={{
                borderBottom: '2px solid #E4EAF6'
              }} data-id="element-339">
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-340">
                    Rank
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-341">
                    Name
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-342">
                    Loans Closed
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-343">
                    Volume
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-344">
                    Avg Close
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-345">
                {topPerformers.map((p, i) => <tr key={p.rank} style={{
                borderBottom: '1px solid #E4EAF6',
                background: i === 0 ? '#EBF5FB' : 'transparent'
              }} data-id="element-346">
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 18,
                  width: 40,
                  textAlign: 'center'
                }} data-id="element-347">
                      {rankLabels[i]}
                    </td>
                    <td style={{
                  padding: '12px 8px'
                }} data-id="element-348">
                      <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                  }} data-id="element-349">
                        <div style={{
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      background: p.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 11,
                      fontWeight: 900,
                      color: 'white',
                      transform: 'skewX(-4deg)'
                    }} data-id="element-350">
                          {p.avatar}
                        </div>
                        <div data-id="element-351">
                          <div style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: '#1A2B3C'
                      }} data-id="element-352">
                            {p.name}
                          </div>
                          <div style={{
                        fontSize: 11,
                        color: '#5A6A8A'
                      }} data-id="element-353">
                            {p.role}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 14,
                  fontWeight: 800,
                  color: '#1A2B3C',
                  textAlign: 'right'
                }} data-id="element-354">
                      {p.loans}
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 14,
                  fontWeight: 800,
                  color: '#2B8DC4',
                  textAlign: 'right'
                }} data-id="element-355">
                      {p.volume}
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 12,
                  color: '#5A6A8A',
                  textAlign: 'right'
                }} data-id="element-356">
                      {p.avgClose}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20
      }} data-id="element-357">
          {/* Swift Coin Counter */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '24px',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: '#1A2B3C',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
        }} data-id="element-358">
            <h3 style={{
            fontSize: 16,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: '0 0 16px',
            fontStyle: 'italic',
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }} data-id="element-359">
              <CoinsIcon size={18} color="#D4A017" data-id="element-360" /> Swift Coin Leaders
            </h3>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12
          }} data-id="element-361">
              {coinLeaders.map((p, i) => <div key={p.rank} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12
            }} data-id="element-362">
                  <div style={{
                fontSize: 14,
                fontWeight: 800,
                color: '#A0AECB',
                width: 16
              }} data-id="element-363">
                    {p.rank}
                  </div>
                  <div style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                background: p.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                fontWeight: 900,
                color: 'white',
                transform: 'skewX(-4deg)'
              }} data-id="element-364">
                    {p.avatar}
                  </div>
                  <div style={{
                flex: 1
              }} data-id="element-365">
                    <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 4
                }} data-id="element-366">
                      <span style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#1A2B3C'
                  }} data-id="element-367">
                        {p.name}
                      </span>
                      <span style={{
                    fontSize: 12,
                    fontWeight: 800,
                    color: '#D4A017'
                  }} data-id="element-368">
                        {p.coins} 🪙
                      </span>
                    </div>
                    <div style={{
                  height: 4,
                  background: '#E4EAF6',
                  borderRadius: 2,
                  overflow: 'hidden'
                }} data-id="element-369">
                      <div style={{
                    height: '100%',
                    width: `${p.coins / coinLeaders[0].coins * 100}%`,
                    background: '#D4A017',
                    borderRadius: 2
                  }} data-id="element-370" />
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Director Stats */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '24px',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: '#2B8DC4',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
        }} data-id="element-371">
            <h3 style={{
            fontSize: 16,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: '0 0 16px',
            fontStyle: 'italic',
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }} data-id="element-372">
              <UsersIcon size={18} color="#2B8DC4" data-id="element-373" /> Director Stats
            </h3>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }} data-id="element-374">
              <div style={{
              padding: '12px',
              borderRadius: 8,
              background: '#F4F8FC',
              border: '1px solid #E4EAF6'
            }} data-id="element-375">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 8
              }} data-id="element-376">
                  <div style={{
                  width: 24,
                  height: 24,
                  borderRadius: 6,
                  background: '#2B8DC4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 9,
                  fontWeight: 900,
                  color: 'white',
                  transform: 'skewX(-4deg)'
                }} data-id="element-377">
                    CM
                  </div>
                  <div style={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#1A2B3C'
                }} data-id="element-378">
                    Carlos Mendez{' '}
                    <span style={{
                    fontSize: 11,
                    color: '#5A6A8A',
                    fontWeight: 500
                  }} data-id="element-379">
                      · Branch Manager
                    </span>
                  </div>
                </div>
                <div style={{
                display: 'flex',
                gap: 12
              }} data-id="element-380">
                  <div style={{
                  flex: 1
                }} data-id="element-381">
                    <div style={{
                    fontSize: 10,
                    color: '#A0AECB',
                    textTransform: 'uppercase',
                    fontWeight: 700
                  }} data-id="element-382">
                      Team Volume
                    </div>
                    <div style={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#2B8DC4'
                  }} data-id="element-383">
                      $22.4M
                    </div>
                  </div>
                  <div style={{
                  flex: 1
                }} data-id="element-384">
                    <div style={{
                    fontSize: 10,
                    color: '#A0AECB',
                    textTransform: 'uppercase',
                    fontWeight: 700
                  }} data-id="element-385">
                      Team Loans
                    </div>
                    <div style={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#1A2B3C'
                  }} data-id="element-386">
                      68
                    </div>
                  </div>
                  <div style={{
                  flex: 1
                }} data-id="element-387">
                    <div style={{
                    fontSize: 10,
                    color: '#A0AECB',
                    textTransform: 'uppercase',
                    fontWeight: 700
                  }} data-id="element-388">
                      Team Size
                    </div>
                    <div style={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#1A2B3C'
                  }} data-id="element-389">
                      8
                    </div>
                  </div>
                </div>
              </div>

              <div style={{
              padding: '12px',
              borderRadius: 8,
              background: '#F4F8FC',
              border: '1px solid #E4EAF6'
            }} data-id="element-390">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 8
              }} data-id="element-391">
                  <div style={{
                  width: 24,
                  height: 24,
                  borderRadius: 6,
                  background: '#1A2B3C',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 9,
                  fontWeight: 900,
                  color: 'white',
                  transform: 'skewX(-4deg)'
                }} data-id="element-392">
                    RC
                  </div>
                  <div style={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#1A2B3C'
                }} data-id="element-393">
                    Robert Chen{' '}
                    <span style={{
                    fontSize: 11,
                    color: '#5A6A8A',
                    fontWeight: 500
                  }} data-id="element-394">
                      · COO
                    </span>
                  </div>
                </div>
                <div style={{
                display: 'flex',
                gap: 12
              }} data-id="element-395">
                  <div style={{
                  flex: 1
                }} data-id="element-396">
                    <div style={{
                    fontSize: 10,
                    color: '#A0AECB',
                    textTransform: 'uppercase',
                    fontWeight: 700
                  }} data-id="element-397">
                      Company Vol
                    </div>
                    <div style={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#2B8DC4'
                  }} data-id="element-398">
                      $487M
                    </div>
                  </div>
                  <div style={{
                  flex: 1
                }} data-id="element-399">
                    <div style={{
                    fontSize: 10,
                    color: '#A0AECB',
                    textTransform: 'uppercase',
                    fontWeight: 700
                  }} data-id="element-400">
                      Direct Reports
                    </div>
                    <div style={{
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#1A2B3C'
                  }} data-id="element-401">
                      4
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}